export const userRoutes = {
  hub: 'users/hub',
  cintraHub: 'users/cintra-hub'
};
